export const GET_LOGS_LISTING = "GET_LOGS_LISTING"
export const GET_LOGS_LISTING_SUCCESS = "GET_LOGS_LISTING_SUCCESS"
export const GET_LOGS_LISTING_FAILED = "GET_LOGS_LISTING_FAILED"

export const GET_ACTIVITY_LOG = "GET_ACTIVITY_LOG"
export const GET_ACTIVITY_LOG_SUCCESS = "GET_ACTIVITY_LOG_SUCCESS"
export const GET_ACTIVITY_LOG_FAILED = "GET_ACTIVITY_LOG_FAILED"
